import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Collapse from "react-bootstrap/Collapse";
import PageTitle from "../../layouts/PageTitle";
import Swal from "sweetalert2";
import { getSubscribeUsersLogs } from "../../../services/UserService";

const UserSubscribeLogs = () => {
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const hasFetched = useRef(false);

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    const fetchUserLogs = async (pageNumber = 1, query = "") => {
        try {
            setLoading(true);
            const response = await getSubscribeUsersLogs(pageNumber, limit, query);
            const { data, pagination } = response.data;
            setUsers(data || []);
            setTotalPages(pagination?.totalPages || 0);
            setTotalItems(pagination?.totalItems || 0);
            setPage(pagination?.page || 1);
        } catch (error) {
            console.error("Error fetching users:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!hasFetched.current) {
            fetchUserLogs(1);
            hasFetched.current = true;
        }
    }, []);

    const handleSearch = () => {
        setPage(1);
        fetchUserLogs(1, searchTerm);
    };

    const handleReset = () => {
        setSearchTerm("");
        setPage(1);
        fetchUserLogs(1);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
            fetchUserLogs(newPage, searchTerm);
        }
    };

    return (
        <>
            <PageTitle
                activeMenu="Subscribe User Logs"
                motherMenu="Settings"
                activeMenuLink={"subscribe-user-log"}
                motherMenuLink={"settings"}
            />
            <div className="row">
                <div className="col-xl-12">
                    <div className="filter cm-content-box box-primary">
                        <div className={`content-title`} onClick={() => setOpen(!open)}>
                            <div className="cpa">
                                <i className="fas fa-filter me-2"></i>Filter
                            </div>
                            <div className="tools">
                                <Link
                                    to={"#"}
                                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>
                        <Collapse in={open}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-3 col-sm-6">
                                            <label className="form-label">Name</label>
                                            <input
                                                type="text"
                                                className="form-control mb-3 mb-xl-0"
                                                id="exampleFormControlInput1"
                                                placeholder="Name"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-xl-3 col-sm-6 align-self-end">
                                            <button
                                                className="btn btn-primary me-2 rounded-sm"
                                                title="Click here to Search"
                                                type="button"
                                                onClick={handleSearch}
                                            >
                                                <i className="fa fa-search me-1"></i>Filter
                                            </button>
                                            <button
                                                className="btn btn-danger light rounded-sm"
                                                title="Click here to remove filter"
                                                type="button"
                                                onClick={handleReset}
                                            >
                                                <i className="fa fa-undo me-1"></i>
                                                Remove Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </div>
                    <div className="filter cm-content-box box-primary">
                        <div className={`content-title`} onClick={() => setOpen2(!open2)}>
                            <div className="cpa">
                                <i className="fas fa-user me-1" />
                                User List
                            </div>
                            <div className="tools">
                                <Link
                                    to={"#"}
                                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                >
                                    <i className="fas fa-angle-up"></i>
                                </Link>
                            </div>
                        </div>
                        <Collapse in={open2}>
                            <div className="cm-content-body form excerpt">
                                <div className="card-body py-3">
                                    {loading ? (
                                        <p>Loading...</p>
                                    ) : (
                                        <div className="table-responsive order-list-table">
                                            <div
                                                id="blog_wrapper"
                                                className="dataTables_wrapper no-footer"
                                            >
                                                <table className="table table-responsive-lg table-condensed flip-content">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-black">S.No</th>
                                                            <th className="text-black">Email</th>
                                                            <th className="text-black">Status</th>
                                                            <th className="text-black">Sent At</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {users.length > 0 ? (
                                                            users.map((item, ind) => (
                                                                <tr key={ind}>
                                                                    <td>{(page - 1) * limit + ind + 1}</td>
                                                                    <td className="truncate">{item.email}</td>
                                                                    <td>
                                                                        <span
                                                                            className={`badge d-inline-block text-capitalize ${item.status === "sent"
                                                                                ? "bg-success"
                                                                                : item.status === "failed"
                                                                                    ? "bg-danger"
                                                                                    : "bg-warning"
                                                                                }`}
                                                                        >
                                                                            {item.status}
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        {new Date(
                                                                            item.createdAt
                                                                        ).toLocaleDateString("en-GB", {
                                                                            day: "2-digit",
                                                                            month: "short",
                                                                            year: "numeric",
                                                                        })}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="4" className="text-center">
                                                                    No subscribe users logs found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                                {totalPages > 0 && (
                                                    <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                                                        <div className="dataTables_info">
                                                            {totalItems > 0 && (
                                                                <>
                                                                    Showing {(page - 1) * limit + 1} to{" "}
                                                                    {Math.min(page * limit, totalItems)} of{" "}
                                                                    {totalItems} entries
                                                                </>
                                                            )}
                                                        </div>

                                                        <div
                                                            className="dataTables_paginate paging_simple_numbers"
                                                            id="example2_paginate"
                                                        >
                                                            {/* Prev button */}
                                                            <Link
                                                                className={`paginate_button previous ${page === 1 ? "disabled" : ""
                                                                    }`}
                                                                to="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    if (page > 1) handlePageChange(page - 1);
                                                                }}
                                                            >
                                                                <i className="fa fa-angle-double-left" />
                                                            </Link>

                                                            <span>
                                                                {Array.from(
                                                                    { length: totalPages },
                                                                    (_, i) => i + 1
                                                                )
                                                                    .filter((i) => {
                                                                        // Always show first 2 and last 2
                                                                        if (i <= 2 || i > totalPages - 2)
                                                                            return true;
                                                                        // Show nearby pages of the current one
                                                                        if (Math.abs(page - i) <= 1) return true;
                                                                        return false;
                                                                    })
                                                                    .reduce((acc, i, index, arr) => {
                                                                        // Add ellipsis between distant page numbers
                                                                        if (index > 0 && i - arr[index - 1] > 1)
                                                                            acc.push("ellipsis");
                                                                        acc.push(i);
                                                                        return acc;
                                                                    }, [])
                                                                    .map((item, index) =>
                                                                        item === "ellipsis" ? (
                                                                            <span
                                                                                key={index}
                                                                                className="paginate_button disabled"
                                                                            >
                                                                                ...
                                                                            </span>
                                                                        ) : (
                                                                            <Link
                                                                                key={index}
                                                                                to="#"
                                                                                className={`paginate_button ${page == item ? "current" : ""
                                                                                    }`}
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handlePageChange(item);
                                                                                }}
                                                                            >
                                                                                {item}
                                                                            </Link>
                                                                        )
                                                                    )}
                                                            </span>

                                                            {/* Next button */}
                                                            <Link
                                                                className={`paginate_button next ${page === totalPages ? "disabled" : ""
                                                                    }`}
                                                                to="#"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    if (page < totalPages) handlePageChange(page + 1);
                                                                }}
                                                            >
                                                                <i className="fa fa-angle-double-right" />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Collapse>
                    </div>
                </div>
            </div>
        </>
    );
};
export default UserSubscribeLogs;